<template>
    <div :style="{opacity:isOpacity}" style="transition: 0.3s">
      <section class="ch-gw-page-banner product_img" :style="{backgroundImage:'url('+ urls.a7 +')'}" >
      <div class="container">
        <div class="row product_img_row" >
          <img :src="urls.a6">
        </div>
      </div>
    </section>

    <section class="ch-gw-page-grids" style="background-color: #F0F2F7;" v-if="screenWidth>=992">
      <div class="container" >
        <div class="row" style="width: 100%;height: 4.5rem;margin: 0 auto;display: flex;flex-wrap: nowrap;">
          <a href="javascript:void(0);" @click="clickProduct('')" style="width: 13rem;height: 100%;" >
            <div  :class="{'product-selected':productClassification == '','product-uncheck':productClassification !== ''}">所有产品</div>
          </a>
          <div style="width: 100%;height: 100%;">
            <el-carousel :autoplay="false" indicator-position="none" height="4.5rem" arrow="always">
              <el-carousel-item v-for="(item,index) in productHeavy" :key="index">
                <a href="javascript:void(0);" @click="clickProduct(i)" style="width: 13rem;height: 100%;border-left: 1px solid rgba(0,0,0,0.1);" v-for="(i,index) in item">
                  <div :class="{'product-selected':productClassification == i,'product-uncheck':productClassification !== i}">
                    <div style="width: 90%;height: 90%;line-height: 2rem;display: flex;align-items: center;justify-content: center;text-overflow: ellipsis;display: -webkit-box;word-break:break-all;text-overflow: -o-ellipsis-lastline;line-clamp: 2;-webkit-box-orient: vertical; overflow:hidden;text-overflow:ellipsis;-webkit-line-clamp: 2;">{{ i }}</div>
                  </div>
                </a>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
    </section>

    <section class="ch-gw-page-grids" style="background-color: #F0F2F7;" v-if="screenWidth<=991">
      <div class="container m_container" style="width: 100%;height: 3.5rem;position: relative;;display: flex;align-items: center;justify-content: center;">
        <i class="el-icon-arrow-left" style="font-size: 1.5rem;position: absolute;left: 1rem;" @click="backParentDate()" v-show="JSON.stringify(parentDate) !== '{}'"></i>
        <div  style="margin: 0 auto;">{{ proName }}</div>
        <i class="el-icon-menu" style="font-size: 1.5rem;position: absolute;right: 1rem;"></i>
        <el-select v-model="proName" @change="clickProduct(proName)" placeholder="请选择" style="position: absolute;width: 10px;right: 4rem;opacity: 0;">
          <el-option
            v-for="item in mproductHeavy"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
      </div>
      
    </section>

    <!-- 

       <i class="el-icon-menu" style="font-size: 1.5rem;"></i>
     -->

      <!-- ====== Blog Start ====== -->
      <index @getDataDetailed="getData" v-show="JSON.stringify(parentDate) == '{}'" :detaileds="detaileds" ref="proLeds"></index>
      <detailed :parentDate="parentDate" v-show="JSON.stringify(parentDate) !== '{}'" :screenWidth="screenWidth"></detailed>
      <div style="width: 100%;display: flex;justify-content: center;padding-bottom: 2rem;">
        <el-pagination v-show="JSON.stringify(parentDate) == '{}'"
            background
            layout="prev, pager, next"
            :page-size="pageSize"
            :total="pageCount"
            @current-change="pagesChange">
        </el-pagination>
        
      </div>
    </div>
</template>

<script>
import detailed from '@/components/product/detailed'
import index from '@/components/product/index'
import {queryProduct } from "@/utils/gw";
export default {
  components:{
  index,
  detailed
  },
  name: 'product',
  data () {
    return {
      msg: '首页',
      urls:{
        a6: require('@/assets/ch/cpzx-wz.png'),
        a7: require('@/assets/ch/cpzx.png'),
      },
      pageIndex:1,
      pageCount:0,
      pageSize:0,
      isOpacity:0,
      productClassification:'',
      parentDate:{},
      detaileds:[],
      pname:'',
      pfatherUrl:'',
      productHeavy:[],
      mproductHeavy:[],
      proName:'所有产品'
    }
  },
  props:['screenWidth'],
  mounted() {
    var that = this
    var i = setTimeout(function(){
      that.isOpacity = 1
      clearTimeout(i)
    },200)
    this.queryProduct().then((e)=>{

      this.pfatherUrl = that.getQueryString("fatherUrl")
      if(this.pfatherUrl == null){
        return ;
      }

      this.pname = that.getQueryString("name")
      if(this.pname == null){
        return ;
      }

      for(var d in that.detaileds){

        if(that.detaileds[d].productName == this.pname){
          that.$refs.proLeds.clickme(that.detaileds[d])
          return;
        }

        if(that.detaileds[d].productClassification == this.pfatherUrl){
          this.clickProduct(this.pfatherUrl)
          return;
        }

      }
    });
  },
  methods:{
        backParentDate(){
          this.parentDate = {}
        },
        splitArray(arr, len){
            var a_len = arr.length;
            var result = [];  
            for(var i=0;i<a_len;i+=len){     
                result.push(arr.slice(i,i+len)); 
            }    
            return result;
        },
        pagesChange(v){
            console.log(v)
            this.pageIndex = v
            this.queryProduct()
        },
        queryProduct(){
          var that = this
          var u = "?pageIndex="+this.pageIndex
          if(this.productClassification!=''){
            u+="&productClassification="+this.productClassification
          }
         return queryProduct(u).then((e)=>{
              e.data.product.forEach((e)=>{
                e.productImag = e.productImag.split("#").filter(item => item != '')
              })
              this.detaileds = e.data.product
              this.pageCount = e.data.pageCount
              this.pageSize = e.data.pageSize
              this.mproductHeavy = e.data.heavy
              this.productHeavy = this.splitArray(e.data.heavy,4)
              this.mproductHeavy.push('所有产品')
              //.replace(/\s*/g,"");
              
          })
        },
      // childData是由子组件传入的
      getData(childData){
            // var positions = new Array();
            //   var pos = childData.productContent.indexOf("src=");

            //   while(pos > -1){
            //     positions.push(pos);  //将出现位置赋给数组
            //     pos = childData.productContent.indexOf("src=",pos + 1);  //从给定字符出现位置的后一位开始查找
            //   }
              /**
               * display: flex;
                  flex-direction: column;
               */
               childData.productContent = childData.productContent.replaceAll("<p>",'<p style="display: flex;flex-direction: column;" >')
              // childData.productContent = childData.productContent.replaceAll("/dev-api",this.$resources+"")
              //childData.productContent.slice(0," ====== ")
            console.log("item--",childData.productContent)
          this.parentDate = childData
      },
      clickProduct(i){
        console.log(i.length,"---")
        this.proName = i
        window.history.pushState("", "", "/product"); 
        if('所有产品' == i){
          i = ''
        }
        if(this.productClassification !== i){
            this.pageIndex = 1
        }
        this.productClassification = typeof i == 'undefined'?'':i
        this.parentDate = {}
        this.queryProduct()
      },
      getQueryString(name) {
            var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
            var r = window.location.search.substr(1).match(reg);
            if (r != null) {
                return decodeURI(r[2]);
            }
            return 0;
        }
  }
}
</script>

<style>
  .product-selected{
    background: linear-gradient(45deg, #298BF1 , #43ddf1);
    width: 100%;
    height: 100%;
    color: rgb(255,255,255);
    font-size: 1.2rem;
    font-weight: 700;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
  }
  .product-uncheck{
    width: 100%;
    height: 100%;
    color: rgb(66, 66, 66);
    font-size: 1.2rem;
    font-weight: 700;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
  }
</style>


// WEBPACK FOOTER //
// src/components/product.vue